import React from 'react';
import styled from 'styled-components';
import Slider, {Slide} from "@/components/common/ui/swiper";
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import reactHtmlParser from "react-html-parser";
import {Img} from "@/components/common/ui/Img";


const DetailsSliders = ({data}) => {


    console.log(data?.images, 'detailslider')
    const handleSwiperInit = (swiper) => {
        return swiper;
    };

    return (
        <>
        <StyledComponent className={'detailSlider'}>
            {
                data?.images?.length > 0 &&
                <div className="image-gallery-slider">
                    <Slider
                        Swiper
                        modules={[Autoplay, Pagination, Navigation]}
                        slidesPerView={1}
                        speed={1500}
                        spaceBetween={10}
                        draggable={true}
                        navigationLeft={`#details-next`}
                    navigationRight={`#details-prev`}

                    loop={false}
                    >
                    {
                        data?.images?.length > 0 &&
                        data?.images?.map((item, index) => {
                            return (
                                <Slide key={index}>
                                    <div className="img-group-caption">
                                        <div className="img-wrapper-big">
                                            <Img alt={item?.short_desc} src={item?.full_path}/>
                                        </div>
                                        <p>{reactHtmlParser(item?.short_desc)}</p>
                                    </div>
                                </Slide>
                            );
                        })
                    }


                </Slider>

            {

                data?.images?.length > 0 &&
                <div className="navigation">
                <div className="blog-button">
                <div className="slider-nav">
                <ul>
                <li id={'details-prev'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="11.207" height="11.414" viewBox="0 0 11.207 11.414">
                <g id="Arrow" transform="translate(0.707 0.707)">
                    <g id="Group_23756" data-name="Group 23756">
                        <line id="Line_3910" data-name="Line 3910" x1="5" y2="5" fill="none" stroke="#363231" strokeLinecap="round" strokeWidth="1"/>
                        <line id="Line_3911" data-name="Line 3911" x2="5" y2="5" transform="translate(0 5)" fill="none" stroke="#363231" strokeLinecap="round" strokeWidth="1"/>
                    </g>
                    <line id="Line_3912" data-name="Line 3912" x1="10" transform="translate(0 5)" fill="none" stroke="#363231" strokeLinecap="round" strokeWidth="1"/>
                </g>
            </svg>

        </li>
        <li id={'details-next'}>
            <svg xmlns="http://www.w3.org/2000/svg" width="11.207" height="11.414" viewBox="0 0 11.207 11.414">
                <g id="Arrow" transform="translate(-648 -1595.793)">
                    <g id="Group_4823" data-name="Group 4823" transform="translate(653.5 1596.5)">
                        <line id="Line_9" data-name="Line 9" x2="5" y2="5" fill="none" stroke="#363231" strokeLinecap="round" strokeWidth="1"/>
                        <line id="Line_10" data-name="Line 10" x1="5" y2="5" transform="translate(0 5)" fill="none" stroke="#363231" strokeLinecap="round" strokeWidth="1"/>
                    </g>
                    <line id="Line_11" data-name="Line 11" x2="10" transform="translate(648.5 1601.5)" fill="none" stroke="#363231" strokeLinecap="round" strokeWidth="1"/>
                </g>
            </svg>

        </li>
        </ul>
</div>
</div>
</div>
}


</div>
}

</StyledComponent>

</>


)
    ;
};

const StyledComponent = styled.section`
    overflow: hidden;

    .image-gallery-slider {
        position: relative;
        margin-bottom: 60px;

        .navigation {
            position: absolute;
            bottom: -35px;
            right: 0;
        }

        .img-wrapper-big {
            padding-top: calc(570 / 870 * 100%);
            position: relative;
        }

        .swiper-slide-active {
            p {
                transition-delay: 0.7s;
                opacity: 1;
            }
        }

        p {
            opacity: 0;
            transition: 0.7s all cubic-bezier(0.54, 0.32, 0.05, 0.96);
            max-width: 70%;
            margin-top: 35px;
            font-weight: 500;
        }
    }
    
    

`;

export default React.memo(DetailsSliders);
